export const INIT = 'FAN_SELLER:INIT';
export const DONE = 'FAN_SELLER:DONE';
export const FLOW_SYNC = 'FAN_SELLER:FLOW_SYNC';
export const FETCH_ORDER = 'FAN_SELLER:FETCH_ORDER';
export const FETCH_EVENT_INFO = 'FAN_SELLER:FETCH_EVENT_INFO';
export const FETCH_TICKETS_BY_IDS = 'FAN_SELLER:FETCH_TICKETS_BY_IDS';
export const SET_EVENT_ID = 'FAN_SELLER:SET_EVENT_ID';
export const SET_LOCATIONS = 'FAN_SELLER:SET_LOCATIONS';
export const SET_CURRENCY_CODE = 'FAN_SELLER:SET_CURRENCY_CODE';
export const SET_EVENT_INFO = 'FAN_SELLER:SET_EVENT_INFO';
export const SET_ORDER = 'FAN_SELLER:SET_ORDER';
export const SET_ORDER_ID = 'FAN_SELLER:SET_ORDER_ID';
export const SET_TICKET_IDS = 'FAN_SELLER:SET_TICKET_IDS';
export const SET_FLOW = 'FAN_SELLER:SET_FLOW';
export const SET_LISTING_ID = 'FAN_SELLER:SET_LISTING_ID';
export const ANALYTICS_EVENT = 'FAN_SELLER:ANALYTICS_EVENT';
export const ANALYTICS_PAGEVIEW = 'FAN_SELLER:ANALYTICS_PAGEVIEW';
export const ANALYTICS_SET_LISTING_INFO = 'FAN_SELLER:ANALYTICS_SET_LISTING_INFO';
export const ANALYTICS_VIEWABLE_MODULE = 'FAN_SELLER:ANALYTICS_VIEWABLE_MODULE';
export const ANALYTICS_CLEAR_VIEWABLE_MODULES = 'FAN_SELLER:ANALYTICS_CLEAR_VIEWABLE_MODULES';

export const PRICING_VIEW_F2F = 'FAN_SELLER:PRICING_F2F';
export const PRICING_VIEW = 'FAN_SELLER:PRICING';
export const PRICING_HELP_VIEW = 'FAN_SELLER:PRICING_GUIDE';
export const PAYMENT_VIEW = 'FAN_SELLER:PAYMENT';
export const LISTED_VIEW = 'FAN_SELLER:LISTED';
export const UPDATED_VIEW = 'FAN_SELLER:UPDATED';

export const RESET = 'FAN_SELLER:RESET';
export const CONTINUE = 'FAN_SELLER:CONTINUE';
export const CANCEL = 'FAN_SELLER:CANCEL';
export const LOADED = 'FAN_SELLER:LOADED';
export const LOAD_FAILED = 'FAN_SELLER:LOAD_FAILED';
export const SHOW_MODAL_EXT = 'FAN_SELLER:SHOW_MODAL_EXT';
export const CLOSE_MODAL_EXT = 'FAN_SELLER:CLOSE_MODAL_EXT';
export const SHOW_LOADER = 'FAN_SELLER:SHOW_LOADER';
export const HIDE_LOADER = 'FAN_SELLER:HIDE_LOADER';
export const LISTING_CREATED = 'FAN_SELLER:LISTING_CREATED';
export const PRICE_UPDATED = 'FAN_SELLER:PRICE_UPDATED';

export const GO_TO = 'FAN_SELLER:GO_TO';
export const FORWARD = 'FAN_SELLER:FORWARD';
export const FORWARD_SI = 'FAN_SELLER:FORWARD_SI';
export const FROM_NORMAL_TO_SI = 'FAN_SELLER:FROM_NORMAL_TO_SI';
export const BACK = 'FAN_SELLER:BACK';

// for integration purpose, we need to allow host to get flowData before fan-seller is mounted
export const REQUEST_FLOW_DATA = 'FAN_SELLER:REQUEST_FLOW_DATA';

export const FETCH_PAYMENT_OPTIONS = 'FAN_SELLER:FETCH_PAYMENT_OPTIONS';
export const FETCH_PAYMENT_OPTIONS_ABORT = 'FAN_SELLER:FETCH_PAYMENT_OPTIONS_ABORT';
export const FETCH_PAYMENT_OPTIONS_PENDING = 'FAN_SELLER:FETCH_PAYMENT_OPTIONS_PENDING';
export const FETCH_PAYMENT_OPTIONS_REJECTED = 'FAN_SELLER:FETCH_PAYMENT_OPTIONS_REJECTED';
export const FETCH_PAYMENT_OPTIONS_FULFILLED = 'FAN_SELLER:FETCH_PAYMENT_OPTIONS_FULFILLED';

export const FETCH_PRICING = 'FAN_SELLER:FETCH_PRICING';
export const FETCH_NEW_PRICING = 'FAN_SELLER:FETCH_PRICING';
export const UPDATE_PRICING = 'FAN_SELLER:UPDATE_PRICING';
export const UPDATE_PRICING_PENDING = 'FAN_SELLER:UPDATE_PRICING_PENDING';
export const UPDATE_PRICING_REJECTED = 'FAN_SELLER:UPDATE_PRICING_REJECTED';
export const UPDATE_PRICING_FULFILLED = 'FAN_SELLER:UPDATE_PRICING_FULFILLED';
export const FETCH_PRICING_ABORT = 'FAN_SELLER:FETCH_PRICING_ABORT';
export const UPDATE_PRICING_ABORT = 'FAN_SELLER:UPDATE_PRICING_ABORT';
export const GET_NEW_TICKET_GROUP_TOKEN = 'FAN_SELLER:GET_NEW_TICKET_GROUP_TOKEN';

export const GET_URL_SEATGEEK = 'FAN_SELLER:GET_URL_SEATGEEK';

export const FETCH_OFFERS = 'FAN_SELLER:FETCH_OFFERS';
export const FETCH_OFFERS_NEW = 'FAN_SELLER:FETCH_OFFERS_NEW';
export const FETCH_OFFERS_ABORT = 'FAN_SELLER:FETCH_OFFERS_ABORT';

export const ACCEPT_OFFER = 'FAN_SELLER:ACCEPT_OFFER';
export const ACCEPT_OFFER_NEW = 'FAN_SELLER:ACCEPT_OFFER_NEW';
export const SET_OFFER = 'FAN_SELLER:SET_OFFER';
export const SET_PAYOUT_FUNDING_INFO = 'FAN_SELLER:SET_PAYOUT_FUNDING_INFO';
export const SET_PREFER_OFFER = 'FAN_SELLER:SET_PREFER_OFFER';

export const ADD_EVENT_DATE_TO_FORM = 'FAN_SELLER:ADD_EVENT_DATE_TO_FORM';

export const PAYOUT_SELECT_VIEW = 'FAN_SELLER:PAYOUT_SELECT_VIEW';
export const PAYOUT_CARD_FORM = 'FAN_SELLER:PAYOUT_CARD_FORM';
export const PAYOUT_ACH_CHECKING_FORM = 'FAN_SELLER:PAYOUT_ACH_CHECKING_FORM';
export const PAYOUT_ACH_SAVINGS_FORM = 'FAN_SELLER:PAYOUT_ACH_SAVINGS_FORM';
export const PAYOUT_EFT_CHECKING_FORM = 'FAN_SELLER:PAYOUT_EFT_CHECKING_FORM';
export const PAYOUT_EFT_SAVINGS_FORM = 'FAN_SELLER:PAYOUT_EFT_SAVINGS_FORM';
export const REFUND_SELECT_VIEW = 'FAN_SELLER:REFUND_SELECT_VIEW';
export const REFUND_CARD_FORM = 'FAN_SELLER:REFUND_CARD_FORM';
export const SET_PAYOUT_VIEW = 'FAN_SELLER:SET_PAYOUT_VIEW';
export const SET_REFUND_VIEW = 'FAN_SELLER:SET_REFUND_VIEW';

export const SELECT_PAYOUT_METHOD = 'FAN_SELLER:SELECT_PAYOUT_METHOD';
export const SELECT_REFUND_METHOD = 'FAN_SELLER:SELECT_REFUND_METHOD';

export const FETCH_PRICING_REJECTED = 'FAN_SELLER:FETCH_PRICING_REJECTED';
export const FETCH_PRICING_FULFILLED = 'FAN_SELLER:FETCH_PRICING_FULFILLED';
export const FETCH_PRICING_PENDING = 'FAN_SELLER:FETCH_PRICING_PENDING';

export const FETCH_OFFERS_REJECTED = 'FAN_SELLER:FETCH_OFFERS_REJECTED';
export const FETCH_OFFERS_FULFILLED = 'FAN_SELLER:FETCH_OFFERS_FULFILLED';
export const FETCH_OFFERS_PENDING = 'FAN_SELLER:FETCH_OFFERS_PENDING';

export const FETCH_PAYMENT_OPTION = 'FAN_SELLER:FETCH_PAYMENT_OPTION';
export const FETCH_PAYMENT_OPTION_PENDING = 'FAN_SELLER:FETCH_PAYMENT_OPTION_PENDING';
export const FETCH_PAYMENT_OPTION_FULFILLED = 'FAN_SELLER:FETCH_PAYMENT_OPTION_FULFILLED';
export const FETCH_PAYMENT_OPTION_REJECTED = 'FAN_SELLER:FETCH_PAYMENT_OPTION_REJECTED';

export const SET_PRICE_PER_TICKET = 'FAN_SELLER:SET_PRICE_PER_TICKET';
export const CREATE_LISTING = 'FAN_SELLER:CREATE_LISTING';
export const CREATE_LISTING_PENDING = 'FAN_SELLER:CREATE_LISTING_PENDING';
export const CREATE_LISTING_REJECTED = 'FAN_SELLER:CREATE_LISTING_REJECTED';
export const CREATE_LISTING_FULFILLED = 'FAN_SELLER:CREATE_LISTING_FULFILLED';
export const CREATE_LISTING_ABORT = 'FAN_SELLER:CREATE_LISTING_ABORT';
export const CREATE_LISTING_NEW = 'FAN_SELLER:CREATE_LISTING_NEW';
export const CREATE_LISTING_NEW_PENDING = 'FAN_SELLER:CREATE_LISTING_NEW_PENDING';
export const CREATE_LISTING_NEW_REJECTED = 'FAN_SELLER:CREATE_LISTING_NEW_REJECTED';
export const CREATE_LISTING_NEW_FULFILLED = 'FAN_SELLER:CREATE_LISTING_NEW_FULFILLED';

export const PAYMENT_TYPE_CARD = 'FAN_SELLER:CARD';
export const PAYMENT_TYPE_CREDIT = 'FAN_SELLER:PAYMENT_TYPE_CREDIT';

export const PAYMENT_ADD_NEW_PAYMENT_OPTION = 'FAN_SELLER:PAYMENT_ADD_NEW_PAYMENT_OPTION';
export const PAYMENT_ADD_NEW_PAYMENT_OPTION_PENDING = 'FAN_SELLER:PAYMENT_ADD_NEW_PAYMENT_OPTION_PENDING';
export const PAYMENT_ADD_NEW_PAYMENT_OPTION_FULFILLED = 'FAN_SELLER:PAYMENT_ADD_NEW_PAYMENT_OPTION_FULFILLED';
export const PAYMENT_ADD_NEW_PAYMENT_OPTION_REJECTED = 'FAN_SELLER:PAYMENT_ADD_NEW_PAYMENT_OPTION_REJECTED';
export const PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION = 'FAN_SELLER:PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION';
export const PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION_PENDING = 'FAN_SELLER:PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION_PENDING';
export const PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION_FULFILLED = 'FAN_SELLER:PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION_FULFILLED';
export const PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION_REJECTED = 'FAN_SELLER:PAYMENT_REQUEST_UPDATE_PAYMENT_OPTION_REJECTED';
export const PAYMENT_REMOVE_PAYMENT_OPTION = 'FAN_SELLER:PAYMENT_REMOVE_PAYMENT_OPTION';
export const PAYMENT_REQUEST_DELETE_PAYMENT_OPTION = 'FAN_SELLER:PAYMENT_REQUEST_DELETE_PAYMENT_OPTION';
export const PAYMENT_REQUEST_DELETE_PAYMENT_OPTION_PENDING =
  'FAN_SELLER:PAYMENT_REQUEST_DELETE_PAYMENT_OPTION_PENDING';
export const PAYMENT_REQUEST_DELETE_PAYMENT_OPTION_FULFILLED =
  'FAN_SELLER:PAYMENT_REQUEST_DELETE_PAYMENT_OPTION_FULFILLED';
export const PAYMENT_REQUEST_DELETE_PAYMENT_OPTION_REJECTED =
  'FAN_SELLER:PAYMENT_REQUEST_DELETE_PAYMENT_OPTION_REJECTED';

export const GET_TICKET_GROUP_TOKEN = 'FAN_SELLER:GET_TICKET_GROUP_TOKEN';
export const GET_TICKET_GROUP_TOKEN_PENDING = 'FAN_SELLER:GET_TICKET_GROUP_TOKEN_PENDING';
export const GET_TICKET_GROUP_TOKEN_FULFILLED = 'FAN_SELLER:GET_TICKET_GROUP_TOKEN_FULFILLED';
export const GET_TICKET_GROUP_TOKEN_REJECTED = 'FAN_SELLER:GET_TICKET_GROUP_TOKEN_REJECTED';

export const FETCH_PRICE_HELP = 'FAN_SELLER:FETCH_PRICE_HELP';
export const FETCH_PRICE_HELP_PENDING = 'FAN_SELLER:FETCH_PRICE_HELP_PENDING';
export const FETCH_PRICE_HELP_FULFILLED = 'FAN_SELLER:FETCH_PRICE_HELP_FULFILLED';
export const FETCH_PRICE_HELP_REJECTED = 'FAN_SELLER:FETCH_PRICE_HELP_REJECTED';
export const FETCH_PRICE_HELP_ABORT = 'FAN_SELLER:FETCH_PRICE_HELP_ABORT';

export const FETCH_CURRENTLY_LISTED = 'FAN_SELLER:FETCH_CURRENTLY_LISTED';
export const FETCH_CURRENTLY_LISTED_PENDING = 'FAN_SELLER:FETCH_CURRENTLY_LISTED_PENDING';
export const FETCH_CURRENTLY_LISTED_FULFILLED = 'FAN_SELLER:FETCH_CURRENTLY_LISTED_FULFILLED';
export const FETCH_CURRENTLY_LISTED_REJECTED = 'FAN_SELLER:FETCH_CURRENTLY_LISTED_REJECTED';
export const FETCH_CURRENTLY_LISTED_ABORT = 'FAN_SELLER:FETCH_CURRENTLY_LISTED_ABORT';

export const FETCH_SECTION_AVAILABILITY = 'FAN_SELLER:FETCH_SECTION_AVAILABILITY';
export const FETCH_SECTION_AVAILABILITY_PENDING = 'FAN_SELLER:FETCH_SECTION_AVAILABILITY_PENDING';
export const FETCH_SECTION_AVAILABILITY_FULFILLED = 'FAN_SELLER:FETCH_SECTION_AVAILABILITY_FULFILLED';
export const FETCH_SECTION_AVAILABILITY_REJECTED = 'FAN_SELLER:FETCH_SECTION_AVAILABILITY_REJECTED';
export const FETCH_SECTION_AVAILABILITY_ABORT = 'FAN_SELLER:FETCH_SECTION_AVAILABILITY_ABORT';

export const FETCH_MAP_GEOMETRY = 'FAN_SELLER:FETCH_MAP_GEOMETRY';
export const FETCH_MAP_GEOMETRY_PENDING = 'FAN_SELLER:FETCH_MAP_GEOMETRY_PENDING';
export const FETCH_MAP_GEOMETRY_FULFILLED = 'FAN_SELLER:FETCH_MAP_GEOMETRY_FULFILLED';
export const FETCH_MAP_GEOMETRY_REJECTED = 'FAN_SELLER:FETCH_MAP_GEOMETRY_REJECTED';
export const FETCH_MAP_GEOMETRY_ABORT = 'FAN_SELLER:FETCH_MAP_GEOMETRY_ABORT';
export const SET_MAP_DATA_SOURCE = 'FAN_SELLER:SET_MAP_DATA_SOURCE';
export const SET_FALLBACK_MAP_IMAGE = 'FAN_SELLER:SET_FALLBACK_MAP_IMAGE';
export const FETCH_PRICE_HELP_NEW = 'FAN_SELLER:FETCH_PRICE_HELP_NEW';
export const FETCH_PRICE_HELP_NEW_FULFILLED = 'FAN_SELLER:FETCH_PRICE_HELP_NEW_FULFILLED';
export const FETCH_PRICE_HELP_NEW_PENDING = 'FAN_SELLER:FETCH_PRICE_HELP_NEW_PENDING';
export const FETCH_PRICE_HELP_NEW_REJECTED = 'FAN_SELLER:FETCH_PRICE_HELP_NEW_REJECTED';

export const PAYOUT_UPDATE_PAYMENT_OPTION = 'FAN_SELLER:PAYOUT_UPDATE_PAYMENT_OPTION';
export const REFUND_UPDATE_PAYMENT_OPTION = 'FAN_SELLER:REFUND_UPDATE_PAYMENT_OPTION';

export const PAYMENT_MOVE_OPTION = 'FAN_SELLER:PAYMENT_MOVE_OPTION';

export const ERROR_MODAL = 'FAN_WALLET:ERROR_MODAL';
export const DELETE_OPTION_MODAL = 'FAN_WALLET:DELETE_OPTION_MODAL';
export const OTHER_COUNTRY_CONFIRMATION_MODAL = 'FAN_WALLET:OTHER_COUNTRY_CONFIRMATION_MODAL';
export const REFUND_INFO_MODAL = 'FAN_WALLET:REFUND_INFO_MODAL';

export const TICKET_LISTINGS_ROUTE = '/list';

export const COLLAPSED_LIST_SIZE = 0;

export const FLOWS = {
  CREATE_LISTING_FLOW: 'create-listing',
  EDIT_LISTING_FLOW: 'edit-listing',
};

export const PENDING_EDIT_PRICE = 'PENDING_EDIT_PRICE';

export const EFT_CHECKING_TYPE = 'checking';
export const EFT_SAVINGS_TYPE = 'savings';
export const EFT_ACCOUNT_TYPES = [
  EFT_CHECKING_TYPE,
  EFT_SAVINGS_TYPE,
  // 'corporate', tmol does not support corporate type
];

export const ACH_CHECKING_TYPE = 'checking';
export const ACH_SAVINGS_TYPE = 'savings';
export const ACH_ACCOUNT_TYPES = [
  ACH_CHECKING_TYPE,
  ACH_SAVINGS_TYPE,
  // 'corporate', tmol does not support corporate type
];

export const PAYOUT_TYPES_MAP = {
  ACH: [
    {
      label: 'ACH.checking',
      value: PAYOUT_ACH_CHECKING_FORM,
    }, {
      label: 'ACH.savings',
      value: PAYOUT_ACH_SAVINGS_FORM,
    },
  ],
  EFT: [
    {
      label: 'EFT.checking',
      value: PAYOUT_EFT_CHECKING_FORM,
    }, {
      label: 'EFT.savings',
      value: PAYOUT_EFT_SAVINGS_FORM,
    },
  ],
  DEBIT: {
    label: 'DEBIT',
    value: PAYMENT_TYPE_CARD,
  },
};

export const PAYOUT_FORM_TO_TYPE_MAP = {
  [PAYOUT_ACH_CHECKING_FORM]: 'checking',
  [PAYOUT_ACH_SAVINGS_FORM]: 'savings',
  [PAYOUT_EFT_CHECKING_FORM]: 'checking',
  [PAYOUT_EFT_SAVINGS_FORM]: 'savings',
  [PAYOUT_CARD_FORM]: PAYMENT_TYPE_CARD,
};

export const PAYOUT_TYPE_TO_FORM_MAP = {
  ACH: PAYOUT_ACH_CHECKING_FORM,
  EFT: PAYOUT_EFT_CHECKING_FORM,
  DEBIT: PAYOUT_CARD_FORM,
};

export const CAD_CURRENCY = 'CAD';
export const CAD_CURRENCY_SYMBOL = 'CA$';

export const GLOBAL_ERROR_CODES = {
  GENERIC: 500,
  MAINTENANCE: 503,
  NOT_FOUND: 404,
};

export const GLOBAL_ERROR_TYPES = {
  TIMEOUT: 'Dependent Service Timeout',
};

export const EVENT_ID = '{eventId}';

export const ACH_TRANSACTION_ERRORS = {
  TAXHOLD: 'THLD',
  AUTOHOLD: 'AHLD',
  MANUALHOLD: 'MHLD',
  PENDING: 'PENDING',
};

export const BANKCODE_ERRORS = {
  BLANK: 'BLANK',
  CALLFORAUTH: 'CALL_FOR_AUTH',
  EXPIRATIONDATE: 'EXP_DATE',
  MISSCVV: 'MISSING_CVV',
  INVALIDACCDATA: 'INVALID_ACC_DATA',
  GENERAL: 'GENERAL_DECLINE',
};

export const BANKACC_ERRORS = {
  PENDING_DEBIT: 'PENDING_DEBIT_VERIFICATION',
  PENDING_ACH_EFT: 'PENDING_ACH_EFT_VERIFICATION',
  FAILED_PAYOUT: 'FAILED_PAYOUT_ATTEMPT',
  BANK_GENERAL: 'BANK_ACCOUNT_GENERAL_FAILURE',
};

export const UNSOLD_LISTING_ALERTS = {
  CANCELLED_FAN: 'CANCELED_USER',
  CANCELLED_SUPPORT: 'CANCELED_ADMIN',
  CANCELLED_GENERAL: 'CANCELED_GENERAL',
  SELL_INSTANTLY_CANCELLED: 'SELL_INSTANTLY_CANCELED',
};

export const RESALE_NOT_ELIGIBLE_ERRORS = {
  PENDING_OFFER: 'RESALE_NOT_ELIGIBLE.PENDING_OFFER',
  TICKET_LISTED: 'RESALE_NOT_ELIGIBLE.TICKET_LISTED',
  TICKET_SOLD: 'RESALE_NOT_ELIGIBLE.TICKET_SOLD',
  POSTING_DISABLED: 'PostingResaleDisabledException',
};

export const FETCH_DISCOVERY_ID = 'FAN_SELLER:FETCH_DISCOVERY_ID';
